module.exports = __webpack_public_path__ + "assets/checkbox.51146e4f.svg";